import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaShippingFast, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import logo from "../images/logo-white.png";
import logoEng from "../images/logo_eng.png";

const decodeHtmlEntities = (value) => {
  if (!value || typeof document === "undefined") {
    return value || "";
  }

  const textarea = document.createElement("textarea");
  let decodedValue = value;
  let previousValue = "";

  while (decodedValue !== previousValue) {
    previousValue = decodedValue;
    textarea.innerHTML = decodedValue;
    decodedValue = textarea.value;
  }

  return decodedValue;
};

const setMetaTag = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const Track = () => {
  const router = new URLSearchParams(window.location.search);
  const [orderId, setOrderId] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [returnPolicies, setReturnPolicies] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const [isReturnPolicyOpen, setIsReturnPolicyOpen] = useState(false);
  const decodedReturnPolicyDescription = decodeHtmlEntities(
    returnPolicies?.description,
  );

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const orderId = queryParams.get("order_id");
    setOrderId(orderId);
  }, []);
  const [isEngHome, setIsEngHome] = useState(false);

  useEffect(() => {
    if (!orderInfo) return;

    const displayedOrderId = orderInfo.return_order_id || orderInfo.order_id;
    const orderLabel = orderInfo.return_order_id ? "Return" : "Order";
    const total =
      orderInfo.total < 0 || orderInfo.total == 0 || orderInfo.total == "0"
        ? "0"
        : orderInfo.total || "0";
    const title = `${orderLabel} #${displayedOrderId} | ${orderInfo.customer_name || "Customer"}`;
    const description = `${orderLabel} ID: #${displayedOrderId} • Customer: ${orderInfo.customer_name || "-"} • Total: ${total} • Telephone: ${orderInfo.telephone || "-"}`;

    document.title = title;
    setMetaTag("name", "description", description);
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:url", window.location.href);
    setMetaTag(
      "property",
      "og:image",
      window.location.host === "link.englishhome.com.lb"
        ? `${window.location.origin}/englishhome-logo.png`
        : `${window.location.origin}/ishtari-logo.png`,
    );
    setMetaTag("name", "twitter:card", "summary");
    setMetaTag("name", "twitter:title", title);
    setMetaTag("name", "twitter:description", description);
  }, [orderInfo]);

  useEffect(() => {
    if (window.location.host == "link.englishhome.com.lb") {
      setIsEngHome(true);
    }

    const link =
      window.location.host == "link.ishtari.com" ||
      window.location.host == "localhost:3001"
        ? "https://www.ishtari-mobile.com/"
        : isEngHome
          ? "https://www.englishhome.com.lb/api/"
          : "https://motor.ishtari.com.gh/";

    if (orderId) {
      axios
        .get(
          `${link}v2/index.php?route=stockapi/order/getOrdersInfo&order_id=` +
            orderId,
        )
        .then((res) => {
          setOrderInfo(res?.data?.data);
          setReturnPolicies(res?.data?.policies?.return);
        });
    }
  }, [orderId]);
  return (
    <div className=" font-poppins text-left flex flex-col min-h-screen bg-dgreyRate justify-start">
      {isEngHome ? (
        <div className=" z-50 sticky top-0 flex justify-between px-5 text-center w-full py-4  bg-white ">
          <img src={logoEng} width={200} height={100} />
        </div>
      ) : (
        <div className=" z-50 sticky top-0 flex justify-between px-5 text-center w-full py-4  bg-dbase ">
          <img src={logo} width={100} height={70} />
        </div>
      )}

      {orderInfo && (
        <div className="md:container md:mx-auto max-md:px-2 mt-5">
          <h2 className=" text-3xl text-dblackk font-extrabold">
            {orderInfo.return_order_id ? "Return Details" : "Order Details"}
          </h2>

          <div className=" bg-white rounded-md w-full p-3 my-3 flex justify-between">
            <div className=" flex flex-col">
              <h2 className=" text-md font-extrabold">
                <strong>
                  {orderInfo.return_order_id
                    ? `Return_Id: #${orderInfo.return_order_id}`
                    : `Order_Id: #${orderInfo.order_id}`}
                </strong>
              </h2>

              <span className=" text-xs  text-dlabelColor">
                {orderInfo.date_printed
                  ? orderInfo.date_printed
                  : orderInfo.system_comment}
              </span>
            </div>
            {window.location.host == "link.ishtari.com.gh" &&
              orderInfo?.url && (
                <div className="flex justify-end">
                  <a
                    href={orderInfo?.url}
                    target="_blank"
                    className="text-white bg-blue-600 hover:bg-blue-500 rounded-md py-1 px-3 mt-1"
                  >
                    Pay
                  </a>
                </div>
              )}
          </div>

          {returnPolicies && (
            <div className="my-3 w-full overflow-hidden rounded-md bg-white">
              <button
                type="button"
                onClick={() => setIsReturnPolicyOpen((prev) => !prev)}
                className="flex w-full items-center justify-between px-3 py-2.5 text-left"
              >
                <span
                  className={`text-md font-bold ${
                    isReturnPolicyOpen
                      ? isEngHome
                        ? "text-blue-700"
                        : "text-dblue"
                      : "text-dblackk"
                  }`}
                >
                  {returnPolicies?.title}
                </span>
                {isReturnPolicyOpen ? (
                  <MdKeyboardArrowDown
                    className={`h-6 w-6 font-bold ${
                      isEngHome ? "text-blue-700" : "text-dblue"
                    }`}
                  />
                ) : (
                  <MdKeyboardArrowRight className="h-6 w-6 text-dblackk" />
                )}
              </button>

              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  isReturnPolicyOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  {decodedReturnPolicyDescription && (
                    <div
                      className="border-t border-dgrey px-4 pb-4 pt-3 text-sm leading-6 text-dblackk [&_a]:text-dblue [&_a]:underline [&_h1]:mb-3 [&_h1]:text-base [&_h1]:font-bold [&_h2]:mb-3 [&_h2]:text-base [&_h2]:font-bold [&_h3]:mb-3 [&_h3]:text-base [&_h3]:font-bold [&_li]:mb-2 [&_p]:mb-3 [&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5"
                      dangerouslySetInnerHTML={{
                        __html: decodedReturnPolicyDescription,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          <div className=" bg-white rounded-md w-full p-2 my-3">
            <div className=" grid   grid-cols-3 max-md:grid-cols-1 gap-5 w-full">
              <div className=" w-full flex flex-row justify-start gap-2">
                <FaUser className=" m-1 text-2xl p-1 rounded-full bg-dplaceHolder" />
                <div className=" flex flex-col tracking-wide  leading-6">
                  <h2 className=" text-md font-extrabold flex justify-start gap-2 mb-2">
                    <strong>Customer Info</strong>
                  </h2>
                  <div className="text-sm  flex justify-start gap-2">
                    <span className="  text-dlabelColor">Name : </span>
                    <strong className="">{orderInfo.customer_name} </strong>
                  </div>
                  <div className="text-sm  flex justify-start gap-2">
                    <span className="  text-dlabelColor">Phone : </span>
                    <strong className="">{orderInfo.telephone} </strong>
                  </div>
                  {orderInfo.shipping_address_1 && (
                    <div className="text-sm flex-col  flex justify-start  gap-2">
                      <span className=" inline-flex  text-dlabelColor">
                        Address_1:{" "}
                      </span>
                      <strong className=" text-dblue ">
                        {orderInfo.shipping_address_1}{" "}
                      </strong>
                    </div>
                  )}
                  {orderInfo.shipping_address_2 && (
                    <div className="text-sm  flex-col flex justify-start  gap-2">
                      <span className=" inline-flex  text-dlabelColor">
                        Address_2:{" "}
                      </span>
                      <strong className=" text-dblue ">
                        {orderInfo.shipping_address_2}{" "}
                      </strong>
                    </div>
                  )}
                  <div className="text-sm  flex justify-start gap-2">
                    <span className="  text-dlabelColor">Zone : </span>
                    <strong className="">{orderInfo.shipping_zone}</strong>
                  </div>
                </div>
              </div>

              {/* <div className='w-full flex flex-row justify-start gap-2'>
    <FaShippingFast className='m-1 text-2xl p-1 rounded-full bg-dplaceHolder'/>
    <div className=' flex flex-col w-fit tracking-wide leading-6'>
<h2 className=' text-md font-extrabold flex justify-start gap-2 mb-2'><strong>Shipping Info</strong></h2>

 <div className='text-sm  flex justify-start gap-2'><span className='  text-dlabelColor'>Logistic : </span><strong className=''>{orderInfo.logistic}</strong></div> 
 <div className='text-sm  flex justify-start gap-2'><span className='  text-dlabelColor'>Track : </span><strong className=''>{orderInfo.track}</strong></div> 
</div>
</div> */}

              <div className="w-full flex flex-row justify-start gap-2">
                <div className=" w-[10%]">
                  <FaShoppingCart className="m-1  text-2xl p-1 rounded-full bg-dplaceHolder" />
                </div>
                <div className=" flex flex-col tracking-wide leading-6">
                  <h2 className=" text-md font-extrabold flex justify-start gap-2 mb-2">
                    <strong>Order Info</strong>
                  </h2>
                  <div className="text-sm  flex justify-start gap-2">
                    <span className="  text-dlabelColor">Total : </span>
                    <strong className=" text-dbase ">
                      {orderInfo.total < 0 ||
                      orderInfo.total == 0 ||
                      orderInfo.total == "0"
                        ? 0
                        : orderInfo.total}
                    </strong>
                  </div>
                  {/* <div className='text-sm  flex justify-start gap-2'><span className='  text-dlabelColor'>Status : </span><strong className=''>{orderInfo.order_status_name} </strong></div>  */}
                  {/* <div className='text-sm  flex justify-start gap-2'><span className='  text-dlabelColor'>Date : </span><strong className=''>{orderInfo.system_comment}</strong></div>  */}
                  <div className="text-sm  flex flex-col justify-start mt-1 gap-2">
                    <span className="  text-dlabelColor">Comment: </span>
                    <strong className=" text-sm   text-dblue font-medium">
                      {orderInfo.comment}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {orderInfo.return_order_id ? (
            <>
              {orderInfo.products.end_products &&
                orderInfo.products.end_products.length > 0 && (
                  <div className=" bg-white rounded-md w-full p-3 my-3">
                    <div className=" flex flex-col">
                      <h2 className=" justify-between w-full flex text-md font-extrabold mb-5">
                        <strong>Received Products</strong>
                        <strong> استلام المنتجات</strong>
                      </h2>

                      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                        <table className="w-full text-sm text-left  text-gray-500 ">
                          <thead className="text-xs text-dblackk uppercase bg-dgreyRate ">
                            <tr>
                              {/* <th scope="col" className="px-6 py-3">
                   Barcode
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Sku
                              </th>
                              <th scope="col" className="px-6 py-3">
                                Image
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                    Model
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Name
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                   Order_Product_id
                </th> */}
                              {/* <th scope="col" className="px-6 py-3">
                   Price
                </th> */}
                              {/* <th scope="col" className="px-6 py-3">
                   Product Id
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Qty
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                   Reason
                </th> */}
                              {/* <th scope="col" className="px-6 py-3">
                   Seller Id
                </th> */}

                              {/* <th scope="col" className="px-6 py-3">
                   Total
                </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {orderInfo.products.end_products.map(
                              (product, index) => (
                                <tr className="bg-white border-b  dark:border-dgrey hover:bg-dgrey dark:hover:bg-gray-200">
                                  {/* <th scope="row" className="px-6 py-4 font-medium text-dblackk whitespace-nowrap ">
                    {product.barcode}
                </th> */}
                                  <td className="px-6 py-4">{product.sku}</td>
                                  <td
                                    onClick={() => {
                                      setOpenImage(product.image);
                                    }}
                                    className="px-6   py-4"
                                  >
                                    {/* <img className={`${openImage == product.barcode?"":""} w-full h-full`} src={product.image}/> */}
                                    <img
                                      className={`w-32  h-full relative  transition-all`}
                                      src={product.image}
                                    />
                                  </td>
                                  {/* <td className="px-6 py-4">
                   {product.model}
                </td> */}
                                  <td className="px-6  group py-4">
                                    <span className="w-[150px] block overflow-hidden group-hover:whitespace-break-spaces whitespace-nowrap text-ellipsis">
                                      {product.name.replace("&amp;", "&")}
                                    </span>
                                  </td>
                                  {/* <td className="px-6 py-4 ">
                  {product.order_product_id}
                </td> */}
                                  {/* <td className="px-6 py-4 ">
                  {product.price}
                </td> */}
                                  {/* <td className="px-6 py-4 ">
                  {product.product_id}
                </td> */}
                                  <td className="px-6 py-4">
                                    {product.quantity}
                                  </td>
                                  {/* <td className="px-6 py-4 ">
                  {product.reason}
                </td> */}
                                  {/* <td className="px-6 py-4 ">
                  {product.seller_id}
                </td> */}

                                  {/* <td className="px-6 py-4 text-dbase font-bold ">
                  ${parseFloat(product.total).toFixed(2)}
                </td> */}
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

              {orderInfo.products.send_products &&
                orderInfo.products.send_products.length > 0 && (
                  <div className=" bg-white rounded-md w-full p-3 my-3">
                    <div className=" flex flex-col">
                      <h2 className=" justify-between w-full flex text-md font-extrabold mb-5">
                        <strong>Send Products</strong>
                        <strong> ارسال المنتجات</strong>
                      </h2>

                      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                        <table className="w-full text-sm text-left text-gray-500 ">
                          <thead className="text-xs text-dblackk uppercase bg-dgreyRate ">
                            <tr>
                              {/* <th scope="col" className="px-6 py-3">
                   Barcode
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Sku
                              </th>
                              <th scope="col" className="px-6 py-3">
                                Image
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                    Model
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Name
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                   Order_Product_id
                </th> */}
                              {/* <th scope="col" className="px-6 py-3">
                   Price
                </th> */}
                              {/* <th scope="col" className="px-6 py-3">
                   Product Id
                </th> */}
                              <th scope="col" className="px-6 py-3">
                                Qty
                              </th>
                              {/* <th scope="col" className="px-6 py-3">
                   Seller Id
                </th> */}

                              {/* <th scope="col" className="px-6 py-3">
                   Total
                </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {orderInfo.products.send_products.map(
                              (product, index) => (
                                <tr className="bg-white border-b  dark:border-dgrey hover:bg-dgrey dark:hover:bg-gray-200">
                                  {/* <th scope="row" className="px-6 py-4 font-medium text-dblackk whitespace-nowrap ">
                    {product.barcode}
                </th> */}
                                  <td className="px-6 py-4">
                                    {product.sku}
                                  </td>
                                  <td
                                    onClick={() => {
                                      setOpenImage(product.image);
                                    }}
                                    className="px-6   py-4"
                                  >
                                    {/* <img className={`${openImage == product.barcode?"":""} w-full h-full`} src={product.image}/> */}
                                    <img
                                      className={`w-32  h-full relative  transition-all`}
                                      src={product.image}
                                    />
                                  </td>
                                  {/* <td className="px-6 py-4">
                   {product.model}
                </td> */}
                                  <td className="px-6  group py-4">
                                    <span className="w-[150px] block overflow-hidden group-hover:whitespace-break-spaces whitespace-nowrap text-ellipsis">
                                      {product.name.replace("&amp;", "&")}
                                    </span>
                                  </td>
                                  {/* <td className="px-6 py-4 ">
                  {product.order_product_id}
                </td> */}
                                  {/* <td className="px-6 py-4 ">
                  {product.price}
                </td> */}
                                  {/* <td className="px-6 py-4 ">
                  {product.product_id}
                </td> */}
                                  <td className="px-6 py-4">
                                    {product.quantity}
                                  </td>
                                  {/* <td className="px-6 py-4 ">
                  {product.seller_id}
                </td> */}

                                  {/* <td className="px-6 py-4 text-dbase font-bold ">
                  ${parseFloat(product.total).toFixed(2)}
                </td> */}
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
            </>
          ) : (
            <div className=" bg-white rounded-md w-full p-3 my-3">
              <div className=" flex flex-col">
                <h2 className=" text-md font-extrabold mb-5">
                  <strong>Products</strong>
                </h2>

                <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                  <table className="w-full text-sm text-left text-gray-500 ">
                    <thead className="text-xs text-dblackk uppercase bg-dgreyRate ">
                      <tr>
                        {/* <th scope="col" className="px-6 py-3">
                 Barcode
              </th> */}
                        <th scope="col" className="px-6 py-3">
                          Sku
                        </th>
                        <th scope="col" className="px-6 py-3">
                          Image
                        </th>
                        {/* <th scope="col" className="px-6 py-3">
                  Model
              </th> */}
                        <th scope="col" className="px-6 py-3">
                          Name
                        </th>
                        {/* <th scope="col" className="px-6 py-3">
                 Order_Product_id
              </th> */}
                        {/* <th scope="col" className="px-6 py-3">
                 Price
              </th> */}
                        {/* <th scope="col" className="px-6 py-3">
                 Product Id
              </th> */}
                        <th scope="col" className="px-6 py-3">
                          Qty
                        </th>
                        {/* <th scope="col" className="px-6 py-3">
                 Seller Id
              </th> */}

                        {/* <th scope="col" className="px-6 py-3">
                 Total
              </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {orderInfo.products.map((product, index) => (
                        <tr className="bg-white border-b  dark:border-dgrey hover:bg-dgrey dark:hover:bg-gray-200 ">
                          {/* <th scope="row" className="px-6 py-4 font-medium text-dblackk whitespace-nowrap ">
                  {product.barcode}
              </th> */}
                          <td className="px-6 py-4">{product.sku}</td>
                          <td className="px-6   py-4">
                            {/* <img className={`${openImage == product.barcode?"":""} w-full h-full`} src={product.image}/> */}
                            <img
                              onClick={() => {
                                setOpenImage(product.image);
                              }}
                              className={`w-32  h-full relative  transition-all`}
                              src={product.image}
                            />
                          </td>
                          {/* <td className="px-6 py-4">
                 {product.model}
              </td> */}
                          <td className="px-6  group py-4">
                            <span className="w-[150px] block overflow-hidden group-hover:whitespace-break-spaces whitespace-nowrap text-ellipsis">
                              {product.name.replace("&amp;", "&")}
                            </span>
                          </td>
                          {/* <td className="px-6 py-4 ">
                {product.order_product_id}
              </td> */}
                          {/* <td className="px-6 py-4 ">
                {product.price}
              </td> */}
                          {/* <td className="px-6 py-4 ">
                {product.product_id}
              </td> */}
                          <td className="px-6 py-4">{product.quantity}</td>
                          {/* <td className="px-6 py-4 ">
                {product.seller_id}
              </td> */}

                          {/* <td className="px-6 py-4 text-dbase font-bold ">
                ${parseFloat(product.total).toFixed(2)}
              </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div
        onClick={() => setOpenImage(null)}
        className={` ${openImage ? "  scale-100" : "  scale-0"} flex  w-full h-full  justify-center text-center fixed bg-dblackOverlay2 `}
      >
        <div
          onClick={(e) => e.preventDefault()}
          className={` relative transition-all  ${openImage ? " translate-y-0  duration-300 opacity-100" : " -translate-y-96 opacity-0"}  w-[40%]  max-md:w-[80%] flex justify-center text-center md:p-28 my-auto `}
        >
          <img className="    w-full h-full " src={openImage}></img>
        </div>
      </div>
    </div>
  );
};

export default Track;
